export default __webpack_public_path__ + "static/media/fabula_desk_banner_2.3f28902c.png";